import React from 'react';

import CustomComponent from 'src/custom-component/CustomComponent';

import { baseSet } from '@utils/common';
import { appMethod as app } from '@utils/app';
import { setPage, pageComponentRefs } from '@utils/page';
import { getCurrentPageQueryParams, randomWord } from '@utils/tools';

import { TechSupport } from 'src/common/tech-support/TechSupport';
import { Filter } from 'src/common/filter/Filter';
import { FormPay } from 'src/common/form-pay/FormPay';
import { SinkingModal } from 'src/common/sinking-modal/SinkingModal';
import { CommunityPublish } from 'src/common/community-publish/CommunityPublish';
import { CommunityPublishType } from 'src/common/community-publish-type/CommunityPublishType';
import { TopNav } from 'src/common/top-nav/TopNav';
import { configWxShare } from '../../utils/weixinSdkConfig';

import './CustomPage.less';

const safeSet = (object, path, value) => {
  return object == null ? object : baseSet(object, path, value)
}

function defineGetter (component, key, getter) {
  Object.defineProperty(component, key, {
    enumerable: true,
    configurable: true,
    get: () => {
      if (getter === 'props') {
        return component.props
      }
      return {
        ...component.props,
        ...component.state
      }
    }
  })
}

/**
 * 处理当前组件列表
 * @param {*} eles 组件数组
 */
const dealEles = (eles) => {
  // 个人中心组件 旧版=>新版
  let userCenterIndex = eles.findIndex((ele) => ele.type === 'user-center');
  if (userCenterIndex > -1) {
    function dealUserCenterHead(oldData) {
      let newData = JSON.parse(JSON.stringify(oldData));
      newData.customFeature = {
        ...oldData.customFeature,
        ...{
        'member': oldData.customFeature["member"] || (oldData.customFeature["personal-mode"] == 3 ? 2 : 1),
        'personal-mode': oldData.customFeature["personal-mode"] || 1,
        'senior-mode': oldData.customFeature["senior-mode"] || 1,
      }}
      return newData;
    }
    // 个人中心头部
    let userCenterHead = JSON.parse(JSON.stringify(eles[userCenterIndex]));
    userCenterHead = dealUserCenterHead(eles[userCenterIndex]);
    userCenterHead['type'] = 'user-center-head';
    function dealUserCenterContent(oldData) {
      let newData = JSON.parse(JSON.stringify(oldData));
      return newData;
    }
    // 个人中心内容
    let userCenterContent = JSON.parse(JSON.stringify(eles[userCenterIndex]));
    userCenterContent = dealUserCenterContent(eles[userCenterIndex]);
    userCenterContent['type'] = 'user-center-content';
    eles.splice(userCenterIndex, 1, userCenterHead, userCenterContent);
  }
};

export default class CustomPage extends React.Component {
  
  id = randomWord(8);

  route = this.props.location.pathname.split('/')[1];

  shareData = {};

  downcountObject = {}; //页面倒计时实例对象

  /**
   * 页面变量
   */
  requesting = false;
  requestNum = 1;
  page_router = this.props.data.router;

  filterRef = React.createRef();
  formPayRef = React.createRef();
  communityPublishRef = React.createRef();
  communityPublishTypeRef = React.createRef();

  constructor(props) {
    super(props);
    // 绑定data到state上
    defineGetter(this, 'data', 'state');
    const { data } = props;
    // 判断当前页是否需要登录
    if (data.customFeature.needLogin && !app.isLogin()) {
      app.goLogin()
      return;
    }
    // 设置当前页面标题
    document.title = data.customFeature.name || data.customFeature.title;
    // 处理当前组件列表
    dealEles(data.eles);
    // 设置当前页面state
    this.state = Object.assign({
      detailData: null, // 详情页数据
    }, data);
    this.customPageRef = React.createRef();
    // 设置当前页组件实例
    setPage(this);
    // WEBAPP: 处理后一个页面回来的回调
    if (app.getCurrentPage().callbackData || app.getCurrentPage().callbackFun) {
      this.currentPage = app.getCurrentPage();
    }
    // 设置分享数据
    setTimeout(() => {
      this.setShareData();
    }, 3000);
    // 控制台输出当前页面信息
    console.log(`【当前应用】${app.getAppId()}\n【当前页面】${document.title}\n【页面路由】${data.router} \n【可复现路径】${window.location.href}`);
  }

  // WEBAPP: 处理后一个页面回来的回调
  handleCurrentPage() {
    if (!this.currentPage) {
      return;
    }
    if (this.currentPage.callbackData) {
      this.setData(this.currentPage.callbackData);
      this.currentPage.clearCallbackData();
    }
    if (this.currentPage.callbackFun) {
      this.currentPage.calllbackFun();
      delete this.currentPage.calllbackFun;
    }
  }

  // 组件挂载完成
  componentDidMount(options = getCurrentPageQueryParams()) {
    // 防止未设置state时进行跳转，则不进行页面初始化
    if (!this.state) {
      return;
    }
    app.onPageLoad(options);
    app.onPageShow();
    // 判断是否需要登录
    app.isNeedRewardModal();
    // WEBAPP: 处理后一个页面回来的回调
    this.handleCurrentPage();
  }
  /**
   * 设置数据
   */
  setData = (obj, callback) => {
    const state = Object.assign({}, this.state)
    Object.keys(obj).forEach(key => {
      safeSet(state, key, obj[key])
    })
    Object.assign(this.state, state)
    this.setState(state)
    setTimeout(() => {
      typeof callback == 'function' && callback()
    }, 0)
  }
  /**
   * 设置组件ref
   */
  setComponentRef = (index, ref) => {
    pageComponentRefs[index] = ref;
  }
  /**
   * 调用组件方法
   */
  callComponentMethod = ({ componentIndex, methodName, argvs }) => {
    if (componentIndex > -1 && pageComponentRefs[componentIndex].current) {
      return pageComponentRefs[componentIndex].current[methodName](...argvs);
    }
  }

  setShareData = () => {
    if (!this.onShareAppMessage) {
      return;
    }
    this.shareData = this.onShareAppMessage();
    let url = this.shareData.path;
    let urlArr = url.split('/');
    url = window.location.origin + '/zc_webapp/' + urlArr[urlArr.length - 1];
    if(!/app_id/.test(url)){
      if(url.indexOf('?') < 0){
        url = url +'?app_id=' + app.getAppId();
      }else{
        url = url +'&app_id=' + app.getAppId();
      }
    }
    this.shareData.path = url;
    if(app.isWeixin()){
      configWxShare({
        title: this.shareData.title,
        link: this.shareData.path,
        imgUrl: this.shareData.imageUrl,
        desc: this.shareData.desc
      })
    }
  }

  // 分享的点击事件（对小程序分享按钮的另种实现）
  shareClickEvent = () =>{
    app.shareClickEvent();
  }

  onShareAppMessage = (e ={}) => {
    // if (e.from == 'button') {
    //   if (e.target.dataset && e.target.dataset.from == 'topicButton') {
    //     let franchiseeId = app.getPageFranchiseeId();
    //     let chainParam = franchiseeId ? '&franchisee=' + franchiseeId : '';
    //     return app.shareAppMessage({
    //       path: '/informationManagement/pages/communityDetail/communityDetail?detail=' + e.target.dataset.id + chainParam,
    //       desc: e.target.dataset.desc
    //     });
    //   }
    // };
    return app.onPageShareAppMessage(e);
  }

  scrollAllowBottom = true;
  onPageScroll = (event) => {
    let customPageDom = this.customPageRef.current;
    event = {
      ...event,
      scrollTop: customPageDom.scrollTop,
      scrollLeft: customPageDom.scrollLeft,
      scrollWidth: customPageDom.scrollWidth,
      scrollHeight: customPageDom.scrollHeight,
    }
    app.onPageScroll(event);
    let scrollDom = this.customPageRef.current;
    if ((scrollDom.scrollTop + scrollDom.clientHeight >= scrollDom.scrollHeight - 100) && this.scrollAllowBottom) {
      this.scrollAllowBottom = false;
      app.onPageReachBottom(this.reachBottomFuc)
    } else if (scrollDom.scrollTop + scrollDom.clientHeight < scrollDom.scrollHeight - 100) {
      this.scrollAllowBottom = true;
    }
  }

  render() {
    // 防止未设置state时进行跳转
    if (!this.state) {
      return null;
    }
    const { eles, detailData, customFeature, techSupport } = this.state;
    const styleObj = {
      backgroundColor: customFeature['background-color'],
      backgroundImage: customFeature['background-image'],
      paddingBottom: app.isTabBarPage() ? '48px' : null,
    };
    const isTabBarPage = app.isTabBarPage();
    return (
      <div ref={this.customPageRef} className="custom-page" style={styleObj} onScroll={this.onPageScroll}>
        <TopNav title={customFeature.name} />
        {eles.map((ele, index) => {
          const ref = React.createRef();
          this.setComponentRef(index, ref);
          return <CustomComponent {...this.props} ref={ref} key={index} index={index} data={ele} detailData={detailData}/>
        })}
        {/* 技术支持 */}
        {
          isTabBarPage && techSupport == 'not_vip' && <TechSupport/>
        }
        <Filter ref={this.filterRef} />
        <FormPay ref={this.formPayRef} />
        <SinkingModal />
        <CommunityPublish ref={this.communityPublishRef} />
        <CommunityPublishType ref={this.communityPublishTypeRef} />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/frame/custom-page/CustomPage.jsx